import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { TypeaheadDataSource, TypeaheadItem } from '@tsq-web/forms';
import { Property } from '@tsq-web/property';
import { tokenizedSearch } from '@tsq-web/search';

@Injectable()
export class PropertiesTypeaheadService implements TypeaheadDataSource<Property> {
  getEntities(search: string, properties: Property[]): Observable<TypeaheadItem<Property>[]> {
    return of(
      properties.reduce<TypeaheadItem<Property>[]>((acc, property) => {
        if (this.matchesSearchQuery(property.fine_description, search)) {
          acc.push({ text: property.fine_description, value: property });
        }

        return acc;
      }, []),
    );
  }

  private matchesSearchQuery(subject: string, search: string): boolean {
    if (!search) {
      return true;
    }
    const filters = search.replace(/\s+/, ' ').trim().split(' ');
    const tokens: string[] = [];
    tokens.push(...subject.split(' '));

    return tokenizedSearch(filters, tokens);
  }
}
